export default "__VITE_ASSET__B5EfbYu2__"